import { Component, OnInit, Input, Injectable } from '@angular/core';
import { AuthGuard } from '../../auth.guard';
import { Articulo } from '../../models/articulo.model';
import { PedidoService } from '../../services/pedido.service';
import { UserService } from '../../services/user.service';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';

@Component({
  standalone: true,
  selector: 'app-articulo-lista',
  templateUrl: './articulo-lista.component.html',
  styleUrls: ['./articulo-lista.component.scss'],
  imports: [CommonModule]
})

export class ArticuloListaComponent implements OnInit {
  @Input() articulo!: Articulo;

  // https://asg-gemmasales.asg-si.net/gemmasales/datos/img/art/thumbs/{{articulo.referencia}}.png
  IMG_URL = environment.SERVER_IMG;
  IMG_EXTENSION = environment.IMG_EXTENSION;
  dia: Date;

  constructor(
    public pedidoService: PedidoService,
    public authService: AuthService,
  ) {
    this.dia = new Date();
  }

  ngOnInit(): void {
  }

  lista(articulo: Articulo) {
    this.pedidoService.sumaLista(articulo);
  }
}
